import * as React from "react";
import { LanguageProvider } from "./context/language";
import { ContactModalProvider } from "./context/contactModal";
import { ComingSoonTooltip } from "./context/comingSoon";
import { AppRoutes } from "./App";

/** Provider stack shared by the browser entry and the prerenderer. `Router` is BrowserRouter or StaticRouter. */
export function Root({ Router, routerProps = {} }) {
  return (
    <React.StrictMode>
      <LanguageProvider>
        <ContactModalProvider>
          <ComingSoonTooltip>
            <Router {...routerProps}>
              <AppRoutes />
            </Router>
          </ComingSoonTooltip>
        </ContactModalProvider>
      </LanguageProvider>
    </React.StrictMode>
  );
}
